import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "@/components/Reveal";
import { PARCOURS, AVANTAGES } from "@/data/content";
import { ShieldCheck, ScrollText, Wallet, FileStack, UserRound, Repeat } from "lucide-react";

const ADV_ICONS = [ScrollText, Wallet, ShieldCheck, FileStack, UserRound, Repeat];

export default function Parcours() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start center", "end center"] });
  const lineHeight = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section id="accompagnement" className="bg-white py-24 lg:py-32" data-testid="parcours-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <Overline>Notre accompagnement</Overline>
          <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-midnight max-w-2xl">
            Un parcours maîtrisé, de l'audit au suivi des économies
          </h2>
        </Reveal>

        <div ref={ref} className="relative mt-16 max-w-3xl mx-auto pl-20">
          {/* vertical track */}
          <div className="absolute left-[27px] top-3 bottom-3 w-px bg-slate-200" />
          <motion.div
            style={{ height: lineHeight }}
            className="absolute left-[27px] top-3 w-px bg-emerald origin-top"
          />

          {PARCOURS.map((step) => (
            <Reveal key={step.n} delay={0.04}>
              <div className="relative mb-10 last:mb-0">
                <div className="absolute -left-20 top-0 h-14 w-14 bg-midnight text-lime flex items-center justify-center font-display font-black z-10">
                  {step.n}
                </div>
                <div className="pt-2">
                  <h3 className="font-display text-xl font-bold text-midnight">{step.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 font-light leading-relaxed">{step.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Pourquoi nous choisir */}
        <div id="pourquoi" className="mt-24 lg:mt-32">
          <Reveal>
            <Overline>Pourquoi nous choisir</Overline>
            <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-midnight max-w-2xl">
              L'expertise d'un interlocuteur unique
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200 mt-12">
            {AVANTAGES.map((a, i) => {
              const Icon = ADV_ICONS[i % ADV_ICONS.length];
              return (
                <Reveal key={a.title} delay={(i % 3) * 0.07} className="bg-white p-8">
                  <Icon className="h-7 w-7 text-emerald mb-4" strokeWidth={1.5} />
                  <h3 className="font-display text-lg font-bold text-midnight">{a.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 font-light leading-relaxed">{a.text}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
